@if (crumbs().length > 0) {
  <nav aria-label="Breadcrumb">
    <ol>
      @for (crumb of crumbs(); track crumb; let isLast = $last) {
        <li>
          <a
            [routerLink]="crumb.link"
            [attr.aria-current]="isLast && !current() ? 'page' : undefined"
            [attr.data-testid]="
              isLast && !current() ? 'active-breadcrumb-link' : undefined
            "
            >{{ crumb.label }}</a
          >
        </li>
      }
      @if (current()) {
        <li>
          <a
            routerLink="."
            aria-current="page"
            data-testid="active-breadcrumb-link"
            >{{ current() }}</a
          >
        </li>
      }
    </ol>
  </nav>
}
